/**
 * Upsell Quantity Sync
 * Intercepts /cart/add requests to set upsell product quantities
 * to match the main product quantity.
 *
 * Respects per-product flags:
 *   data-single-qty="true"  → always add with quantity 1
 *   (default)               → sync quantity with main product
 */
(function () {
  var origFetch = window.fetch;
  window.fetch = function (url, options) {
    if (
      typeof url === 'string' &&
      url.indexOf('cart/add') !== -1 &&
      options &&
      options.body instanceof FormData
    ) {
      var fd = options.body;

      // Collect upsell variant IDs and their flags from product-info-upsell elements
      var upsellIds = new Set();
      var singleQtyIds = new Set();
      document.querySelectorAll('product-info-upsell').forEach(function (el) {
        var id = String(el.dataset.id);
        upsellIds.add(id);
        if (el.dataset.singleQty === 'true') {
          singleQtyIds.add(id);
        }
      });

      if (upsellIds.size > 0) {
        // Parse items from FormData
        var items = {};
        for (var pair of fd.entries()) {
          var key = pair[0], value = pair[1];
          var m = key.match(/^items\[(\d+)]\[(\w+)]$/);
          if (m) {
            if (!items[m[1]]) items[m[1]] = {};
            items[m[1]][m[2]] = value;
          }
        }

        // Find main product quantity (first item NOT matching an upsell ID)
        var mainQty = 1;
        for (var idx in items) {
          if (!upsellIds.has(String(items[idx].id))) {
            mainQty = parseInt(items[idx].quantity) || 1;
            break;
          }
        }

        // Set upsell item quantities
        for (var idx in items) {
          var itemId = String(items[idx].id);
          if (upsellIds.has(itemId)) {
            if (singleQtyIds.has(itemId)) {
              // Single quantity product: always 1
              fd.set('items[' + idx + '][quantity]', '1');
            } else {
              // Normal upsell: sync with main product
              fd.set('items[' + idx + '][quantity]', String(mainQty));
            }
          }
        }
      }
    }

    return origFetch.apply(this, arguments);
  };
})();
